import React, { ReactElement } from "react";

function IconHome({
  fill = "currentColor",
  height = 24,
  width = 18,
}: {
  fill?: string;
  height?: number;
  width?: number;
}): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 15"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4272 8.92857C15.4272 8.90625 15.4272 8.88393 15.416 8.86161L8.99861 3.57143L2.58119 8.86161C2.58119 8.88393 2.57003 8.90625 2.57003 8.92857V14.2857C2.57003 14.6763 2.89369 15 3.28432 15H7.57003V10.7143H10.4272V15H14.7129C15.1035 15 15.4272 14.6763 15.4272 14.2857V8.92857ZM17.916 8.15848C18.0388 8.01339 18.0165 7.77902 17.8714 7.65625L15.4272 5.625V1.07143C15.4272 0.870535 15.2709 0.714285 15.07 0.714285H12.9272C12.7263 0.714285 12.57 0.870535 12.57 1.07143V3.24777L9.84682 0.970981C9.37807 0.580356 8.61914 0.580356 8.15039 0.970981L0.125837 7.65625C-0.0192522 7.77902 -0.0415736 8.01339 0.0811942 8.15848L0.773159 8.98438C0.828962 9.05134 0.918248 9.09598 1.00753 9.10714C1.10798 9.1183 1.19727 9.08482 1.27539 9.02902L8.99861 2.58929L16.7218 9.02902C16.7888 9.08482 16.8669 9.10714 16.9562 9.10714C16.9674 9.10714 16.9785 9.10714 16.9897 9.10714C17.079 9.09598 17.1682 9.05134 17.2241 8.98438L17.916 8.15848Z"
        fill={fill}
      />
    </svg>
  );
}

export default IconHome;
